import { initializeProviders } from '@useblu/blu-lytics';

const mixPanelApiKey = process.env.MIX_PANEL_TOKEN;
const clarityApiKey = process.env.CLARITY_API_KEY;

export default () => {
  initializeProviders(
    [
      { providerName: 'MixPanel', apiKey: mixPanelApiKey },
      { providerName: 'Clarity', apiKey: clarityApiKey },
    ],
    { environment: 'production' },
  );
};
